  /**
   * Enum for all miscellaneous images
   */
  export enum MiscImagesIds {
    OMON_IMARALU = '1M28LGzZ44leHlkKNZ5v5IcBSeUGcWC_j',
    OSAS_FERGUSON = '1Ez1DXD6xRNhw90LQWkRrjdhwX5FKHDoO',
    DANIEL_OSEMEKE = '1678nYttqYkAApWnvLPmYkoPdALzogDbB',
    AKACHUKWU_AJULIBE = '1w_RqnmUl9-wmsNMFkwMPbKspeF0dH_Lo',
    OUR_CULTURE = '1VYaBtUK7j1r_pcB49cchzgTx0lGt0XVG',
    CONTACT_US = '1n88j8eza271BwrTDC-Nq5UIFOhTZYMuD',
    ROLES_HEADER = '17DY88QbmOzM2volO0bTxlJMOvxbG2z_a'
  }